import "./App.scss";
import { useEffect, useState, lazy, Suspense } from "react";
import { useGlobalContext } from "./ContextApi/GlobalContext";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Header from "./Container/Header/Header";
import Footer from "./Container/Footer/Footer";
import AuthModal from "./Container/Modal/AuthModal";
import PlanEventModal from "./Container/Modal/PlanEventModal";
import ProtectedRoute from "./ProtectedRoutes/ProtectedRoute";
import { RouterItems } from "./ProtectedRoutes/RouterItems";

// Lazy Loaded Pages
const HomePage = lazy(() => import("./Pages/HomePage"));
const ContactPage = lazy(() => import("./Pages/ContactPage"));
const NotFound = lazy(() => import("./Pages/NotFoundpage"));
const AboutPage = lazy(() => import("./Pages/AboutPage"));
const GalleryPage = lazy(() => import("./Pages/GalleryPage"));
const EventsPage = lazy(() => import("./Pages/EventsPage"));
const PrivacyPolicyPage = lazy(() => import("./Pages/PrivacyPolicyPage"));
const TermsPage = lazy(() => import("./Pages/TermsPage"));
const EventDetailsPage = lazy(() => import("./Pages/EventDetailsPage"));
const ServicePage = lazy(() => import("./Pages/ServicePage"));
const CityPageDetails = lazy(() => import("./Pages/CityPageDeatils"));
const ExplorePage = lazy(() => import("./Pages/ExplorePage"));
const ServiceDetailsPage = lazy(() => import("./Pages/ServiceDetailsPage"));

// Loading Component
const PageLoader = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-white z-[999999]">
    <div className="w-16 h-16 border-4 border-accent border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function AppContent() {
  const navigate = useNavigate();
  const { state, dispatch } = useGlobalContext();
  const [loginOpen, setLoginOpen] = useState(false);
  const [planEventOpen, setPlanEventOpen] = useState(false);

  const getDatas = async () => { };
  useEffect(() => {
    if (state?.authToken) {
      getDatas();
    }
  }, [state?.authToken]);

  return (
    <>
      <Header isOpenPlan={() => setPlanEventOpen(true)} isOpenLogin={() => setLoginOpen(true)} />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomePage isOpenPlan={() => setPlanEventOpen(true)} />} />

          <Route path="/events" element={<EventsPage isOpenPlan={() => setPlanEventOpen(true)} />} />
          <Route path="/event/:slus" element={<EventDetailsPage />} />

          <Route path="/explore" element={<ExplorePage />} />
          <Route path="/explore/:city" element={<CityPageDetails />} />

          <Route path="/services" element={<ServicePage isOpenPlan={() => setPlanEventOpen(true)} />} />
          <Route path="/service/:slug" element={<ServiceDetailsPage />} />

          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />

          <Route element={<ProtectedRoute />}>
            {RouterItems?.map((route, index) => (
              <Route key={index} path={route?.link} element={route?.page} />
            ))}
          </Route>

          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      {loginOpen && <AuthModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} />}
      {planEventOpen && <PlanEventModal isOpen={planEventOpen} onClose={() => setPlanEventOpen(false)} />}
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
